import { useRoutes, useUrlGenerator } from '@micromag/core/contexts';
import queryString from 'query-string';
import React, { useEffect } from 'react';
// import PropTypes from 'prop-types';
import { Switch, Route, Redirect, useLocation } from 'wouter';

import { useLoggedIn, useUser } from '../../contexts/AuthContext';
import { useOrganisation } from '../../contexts/OrganisationContext';
import HomePage from '../pages/Home';
import HomeOrganisationPage from '../pages/HomeOrganisation';
import OrganisationsPage from '../pages/Organisations';
import AccountPage from '../pages/account/Account';
import ForgotPasswordPage from '../pages/auth/ForgotPassword';
import LoginPage from '../pages/auth/Login';
import ResetPasswordPage from '../pages/auth/ResetPassword';
import OrganisationBrandingPage from '../pages/organisation/Branding';
import OrganisationCreatePage from '../pages/organisation/Create';
import OrganisationFontsPage from '../pages/organisation/Fonts';
import OrganisationInactivePage from '../pages/organisation/Inactive';
import OrganisationInvitePage from '../pages/organisation/Invite';
import OrganisationMediasPage from '../pages/organisation/Medias';
import OrganisationPublishingPage from '../pages/organisation/Publishing';
import OrganisationSettingsPage from '../pages/organisation/Settings';
import OrganisationStatsPage from '../pages/organisation/Stats';
import OrganisationTeamPage from '../pages/organisation/Team';
import OrganisationThemesPage from '../pages/organisation/Themes';
import CompleteProfilePage from '../pages/register/CompleteProfile';
import RegisterPage from '../pages/register/Register';
import StoryContributionsPage from '../pages/stories/Contributions';
// import OrganisationBillingPage from '../pages/organisation/Billing';
// import OrganisationBillingInfoPage from '../pages/organisation/BillingInfo';
// import OrganisationBillingHistoryPage from '../pages/organisation/BillingHistory';
// import OrganisationBillingPlanPage from '../pages/organisation/BillingPlan';
import StoryCreatePage from '../pages/stories/Create';
import StoryEditorPage from '../pages/stories/Editor';
import StoryMediasPage from '../pages/stories/Medias';
import StoryParticipationPage from '../pages/stories/Participation';
import StoryPreviewPage from '../pages/stories/Preview';
import StoryPublishPage from '../pages/stories/Publish';
import StoryQuizPage from '../pages/stories/Quiz';
import StorySettingsPage from '../pages/stories/Settings';
import StoryShowPage from '../pages/stories/Show';
import StorySurveyPage from '../pages/stories/Survey';
import StoryVersionsPage from '../pages/stories/Versions';
import ThemeCreatePage from '../pages/themes/Create';
import ThemeEditorPage from '../pages/themes/Editor';
import ThemeSettingsPage from '../pages/themes/Settings';
import ThemePage from '../pages/themes/Theme';

const propTypes = {};

const defaultProps = {};

const Routes = () => {
    const [location] = useLocation();
    const routes = useRoutes();
    const url = useUrlGenerator();
    const loggedIn = useLoggedIn();
    const user = useUser();
    const hasCompleteProfile = user !== null && user.name !== '';
    const organisation = useOrganisation();
    const HomePageByType = organisation !== null ? HomeOrganisationPage : HomePage;

    // Scroll top on history change
    useEffect(() => {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }, [location]);

    return (
        <Switch>
            {/*
                Catch-all routes when organisation is inactive
            */}
            {loggedIn && organisation !== null && organisation.active === false ? (
                <Route component={OrganisationInactivePage} />
            ) : null}

            {/*
                Home routes
            */}
            {!loggedIn ? <Redirect path={routes.home} to={url('auth.login')} /> : null}
            {!hasCompleteProfile && loggedIn ? (
                <Route path={routes.home}>
                    <Redirect to={routes['register.complete']} />
                </Route>
            ) : null}
            {loggedIn ? <Route path={routes.home} component={HomePageByType} /> : null}

            {/*
                Register routes
            */}
            <Route path={routes.register} component={RegisterPage} />
            <Route path={routes['register.complete']} component={CompleteProfilePage} />

            {/*
                Auth routes
            */}
            {loggedIn ? (
                <Route path={routes['auth.login']}>
                    <Redirect to={url('home')} />
                </Route>
            ) : (
                <Route path={routes['auth.login']} component={LoginPage} />
            )}
            {loggedIn ? (
                <Route path={routes['auth.forgot_password']}>
                    <Redirect to={url('home')} />
                </Route>
            ) : (
                <Route path={routes['auth.forgot_password']} component={ForgotPasswordPage} />
            )}
            {loggedIn ? (
                <Route path={routes['auth.reset_password']}>
                    <Redirect to={url('home')} />
                </Route>
            ) : (
                <Route path={routes['auth.reset_password']} component={ResetPasswordPage} />
            )}

            {/*
                Account routes
            */}
            {!loggedIn ? (
                <Route>
                    <Redirect
                        to={`${url('auth.login')}?${queryString.stringify({
                            next: url('home'),
                        })}`}
                    />
                </Route>
            ) : null}
            <Route path={routes.account} component={AccountPage} />
            {/*
                Organisation routes
            */}
            {organisation === null ? (
                <Route path={routes['organisations.invite']}>
                    <Redirect to={url('home')} />
                </Route>
            ) : null}
            {organisation === null ? (
                <Route path={routes['organisations.settings']}>
                    <Redirect to={url('home')} />
                </Route>
            ) : null}
            {organisation === null ? (
                <Route path={routes['organisations.team']}>
                    <Redirect to={url('home')} />
                </Route>
            ) : null}
            {organisation === null ? (
                <Route path={routes['organisations.themes']}>
                    <Redirect to={url('home')} />
                </Route>
            ) : null}
            {organisation === null ? (
                <Route path={routes['organisations.publishing']}>
                    <Redirect to={url('home')} />
                </Route>
            ) : null}
            {organisation === null ? (
                <Route path={routes['organisations.branding']}>
                    <Redirect to={url('home')} />
                </Route>
            ) : null}
            {organisation === null ? (
                <Route path={routes['organisations.stats']}>
                    <Redirect to={url('home')} />
                </Route>
            ) : null}
            {organisation === null ? (
                <Route path={routes['organisations.index']}>
                    <Redirect to={url('home')} />
                </Route>
            ) : null}
            <Route path={routes['organisations.index']} component={OrganisationsPage} />
            <Route path={routes['organisations.create']} component={OrganisationCreatePage} />
            <Route path={routes['organisations.invite']} component={OrganisationInvitePage} />
            <Route path={routes['organisations.settings']} component={OrganisationSettingsPage} />
            <Route
                path={routes['organisations.settings.fonts']}
                component={OrganisationFontsPage}
            />
            <Route path={routes['organisations.team']} component={OrganisationTeamPage} />
            <Route path={routes['organisations.themes']} component={OrganisationThemesPage} />
            <Route
                path={routes['organisations.publishing']}
                component={OrganisationPublishingPage}
            />
            <Route path={routes['organisations.branding']} component={OrganisationBrandingPage} />
            <Route path={routes['medias.index']} component={OrganisationMediasPage} />
            {/*
                Analytics routes
            */}
            <Route path={routes['organisations.stats']} component={OrganisationStatsPage} />
            <Route path={routes['organisations.stats.screen']} component={OrganisationStatsPage} />
            <Route path={routes['organisations.stats.story']} component={OrganisationStatsPage} />

            {/*
                Stories routes
            */}
            <Route path={routes['stories.create']} component={StoryCreatePage} />
            <Route path={routes['stories.preview.path']} component={StoryPreviewPage} />
            <Route path={routes['stories.preview']} component={StoryPreviewPage} />
            <Route path={routes['stories.editor.path']} component={StoryEditorPage} />
            <Route path={routes['stories.editor']} component={StoryEditorPage} />
            <Route path={routes['stories.publish']} component={StoryPublishPage} />
            <Route path={routes['stories.versions.preview.path']} component={StoryPreviewPage} />
            <Route path={routes['stories.versions.preview']} component={StoryPreviewPage} />
            <Route path={routes['stories.versions.show']} component={StoryShowPage} />
            <Route path={routes['stories.versions.index']} component={StoryVersionsPage} />
            <Route path={routes['stories.settings']} component={StorySettingsPage} />
            <Route path={routes['stories.medias']} component={StoryMediasPage} />
            <Route path={routes['stories.participation']} component={StoryParticipationPage} />
            <Route path={routes['stories.quiz.show']} component={StoryQuizPage} />
            <Route path={routes['stories.contributions.show']} component={StoryContributionsPage} />
            <Route path={routes['stories.survey.show']} component={StorySurveyPage} />
            <Route path={routes['stories.show']} component={StoryShowPage} />
            {/*
                Themes routes
            */}
            <Route path={routes['themes.create']} component={ThemeCreatePage} />
            <Route path={routes['themes.settings']} component={ThemeSettingsPage} />
            <Route path={routes['themes.editor']} component={ThemeEditorPage} />
            <Route path={routes['themes.show']} component={ThemePage} />
        </Switch>
    );
};

Routes.propTypes = propTypes;
Routes.defaultProps = defaultProps;

export default Routes;
